import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { LangProvider } from "@/i18n";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Directory from "@/pages/Directory";
import Detail from "@/pages/Detail";
import Events from "@/pages/Events";
import MapPage from "@/pages/MapPage";
import Favorites from "@/pages/Favorites";
import Survey from "@/pages/Survey";
import About from "@/pages/About";
import AdminLogin from "@/pages/admin/Login";
import AdminDashboard from "@/pages/admin/Dashboard";
import ProposeEvent from "@/pages/ProposeEvent";

function ScrollTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function Shell() {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith("/admin");
  return (
    <div className="min-h-screen flex flex-col bg-calce">
      <ScrollTop />
      {!isAdmin && <Navbar />}
      <main className={`flex-1 ${isAdmin ? "" : "pt-16 lg:pt-[100px]"}`}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/dove-dormire" element={<Directory key="accommodation" type="accommodation" />} />
          <Route path="/ristoranti" element={<Directory key="restaurant" type="restaurant" />} />
          <Route path="/esperienze" element={<Directory key="activity" type="activity" />} />
          <Route path="/sport" element={<Directory key="sport" type="sport" />} />
          <Route path="/cantine" element={<Directory key="winery" type="winery" />} />
          <Route path="/prodotti-tipici" element={<Directory key="product" type="product" />} />
          <Route path="/piatti-tipici" element={<Directory key="dish" type="dish" />} />
          <Route path="/ricette" element={<Directory key="recipe" type="recipe" />} />
          <Route path="/info-utili" element={<Directory key="info" type="info" />} />
          <Route path="/pacchetti" element={<Directory key="offer" type="offer" />} />
          <Route path="/cerca" element={<Directory key="search" type={null} />} />
          <Route path="/scheda/:slug" element={<Detail />} />
          <Route path="/eventi" element={<Events />} />
          <Route path="/mappa" element={<MapPage />} />
          <Route path="/preferiti" element={<Favorites />} />
          <Route path="/sondaggio" element={<Survey />} />
          <Route path="/chi-siamo" element={<About />} />
          <Route path="/proponi-evento" element={<ProposeEvent />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
        </Routes>
      </main>
      {!isAdmin && <Footer />}
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default function App() {
  useEffect(() => {
    document.title = "Follonica Like — Golfo di Follonica";
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <LangProvider>
      <BrowserRouter>
        <Shell />
      </BrowserRouter>
    </LangProvider>
  );
}
